import { render, staticRenderFns } from "./capitalForm.vue?vue&type=template&id=31746769&scoped=true&"
import script from "./capitalForm.vue?vue&type=script&lang=js&"
export * from "./capitalForm.vue?vue&type=script&lang=js&"
import style0 from "./capitalForm.vue?vue&type=style&index=0&id=31746769&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31746769",
  null
  
)

export default component.exports